import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { PacoteDossie } from '../models/pacote-dossie.model';
import { PacoteDossieDisponivel } from '../models/pacote-dossie-disponivel.model';
import { PacoteDossieListParams } from '../models/pacote-dossie-list-params.model';
import { PaginatedResponse } from '../../../core/shared/models/pagination.model';

export const PACOTE_DOSSIE_REPOSITORY = new InjectionToken<PacoteDossieRepository>('PacoteDossieRepository');

export interface PacoteDossieRepository {
  listarTodos(params: PacoteDossieListParams): Observable<PaginatedResponse<PacoteDossie>>;
  buscarPorId(id: number): Observable<PacoteDossie>;
  criar(payload: PacoteDossie): Observable<PacoteDossie>;
  editar(id: number, payload: PacoteDossie): Observable<PacoteDossie>;
  excluir(id: number): Observable<void>;
  retornaPacotesDossieDisponiveis(dossieId: number, propostaId: string): Observable<PacoteDossieDisponivel[]>;
}


